import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const ConfirmationModalInterest = ({ open, close,updateHandler }) => {
    return (
        <Modal open={open}
            centered
            onCancel={close}

            footer={[
                <Button key="submit" onClick={()=>{
                    updateHandler(true);
                    close();
                }} type="primary">
                    Yes
                </Button>,
                <Button key="back" onClick={close}>
                    No
                </Button>,
            ]} title="Confirmation">
            <p>Same Product Available in Cart with Different Interest Rate Do you wish to Change it? </p>
        </Modal>
    );
};

export default ConfirmationModalInterest;